import { render, staticRenderFns } from "./PrivacyLinkAndModal.vue?vue&type=template&id=b43f333c&scoped=true"
import script from "./PrivacyLinkAndModal.vue?vue&type=script&lang=js"
export * from "./PrivacyLinkAndModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43f333c",
  null
  
)

export default component.exports